import React, { Component } from 'react';
import { connect } from "react-redux";
import classes from './guest1.css';

class Guest1 extends React.Component {

  state = {
    chat: '',
    sendChat: ''
  }

  sendtxt = (evnt) => {
    this.setState({chat:evnt.target.value})
  }

  clk = () => {
    var pingChat = this.state.chat;
    this.props.dispatch({type:"PING_GUEST1",pingChat });
    this.setState({chat:''}) 
  }


 render() {

  let chatSec = null;

  console.log('this.props.data.selIndex');
  console.log(this.props.selIndex);
  console.log(this.props.selIndex);

  if (this.props.data[this.props.selIndex].guest1 == undefined) {

    chatSec = (
      <div className={classes.msgBody}>
        <ul className={classes.ulstyle}>
        </ul>
      </div>
    )
  } else {

    console.log('Inside else')
   chatSec = (

     <div className={classes.msgBody}>

      {this.props.data[this.props.selIndex].guest1.map((item,index) => (
       <ul key={index} className={classes.ulstyle}>
        {item}
       </ul>
     ))}

     </div>
 );
}


  return (
   <div className={classes.body} >
     <p className={classes.title}>Guest-1</p>
     {chatSec}
     <input type="text" className={classes.inputbox} onChange={this.sendtxt} value={this.state.chat} />
     <button className={classes.btn} onClick={this.clk}>Send</button>
   </div>
   );
  }}

const mapStateToProps = state => {
    return {
    data: state.data,
    selIndex:state.selIndex,
    switchuser:state.switchuser
  };
};

export default connect(
  mapStateToProps
)(Guest1);
